import { render, staticRenderFns } from "./PDisplayLocation.vue?vue&type=template&id=0cb90d54"
import script from "./PDisplayLocation.vue?vue&type=script&lang=js"
export * from "./PDisplayLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports